export enum ContactTypeSortType {
  Id,
  Name,
  ContactTypeEnum,
  IsDeleted
}
